export const APPROVAL_CHAIN_TEMPLATE_LEVEL_MODEL =
  "approval-chain-template-level";

const approvalChainTemplateLevelModel = {
  level: 0,
  users: {
    jsonApi: "hasMany",
    type: "approval-chain-template-level-users"
  }
};

export default approvalChainTemplateLevelModel;
